import { Outlet } from 'react-router'
import { Footer } from '@/components/Footer'
import { DealerContext } from '@/context/DealerContext'
import { useContext, useEffect } from 'react'
import { setPageMetadata } from '@/utils/seo'

function PersonalLoanLayout() {
  const context = useContext(DealerContext)
  const isDealer = context?.isDealer ?? false

  useEffect(() => {
    setPageMetadata({
      title: 'UDC Finance | Individual Application',
    })
  }, [])

  return (
    <>
      <section className='px-4 md:px-6 lg:px-10 pb-16 lg:pb-20 grow'>
        <Outlet />
      </section>
      {!isDealer && <Footer />}
    </>
  )
}

export default PersonalLoanLayout
